/* eslint-disable logical-assignment-operators */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */

import {
  Button,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Table, TableBody, TableCell, TableHead, TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment';

import { ErrorOutline, History, InfoOutlined, RefreshOutlined, } from '@mui/icons-material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import { v4 } from 'uuid';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import TableShimmer from '../common/components/TableShimmer';
import '../common/tickets.css';
import { useAheadTimeThreshold, useMergedTransportAtts } from '../common/util/permissions';
import { formatDate, isMobile } from '../common/util/utils';
import TableExitsReport from '../main/components/TableExitsReport';
import TimeUpdateBtn from '../main/components/TimeUpdateBtn';
import { useCatch, useEffectAsync } from '../reactHelper';
import scheduleReport from './common/scheduleReport';
import useReportStyles from './common/useReportStyles';
import ReceiptPrintView from './components/ReceiptPrintView';
import ReportFilter from './components/ReportFilter';
import ReportsMenu from './components/ReportsMenu';
import ReceiptPrintViewThermal from './components/ThermalReceiptPrintView';

import { Close as CloseIcon, Map as MapIcon } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CircleIcon from '@mui/icons-material/RadioButtonUnchecked'; // o FiberManualRecord
import { CircularProgress, Drawer, IconButton } from '@mui/material';
import { formatTime } from '../common/util/formatter';
import { useAttributePreference, usePreference } from '../common/util/preferences';
import { calcDiffColor } from '../common/util/transporte';
import MapView from '../map/core/MapView';
import MapCamera from '../map/MapCamera';
import MapGeofence from '../map/MapGeofence';
import MapPositions from '../map/MapPositions';
import MapRoutePath from '../map/MapRoutePath';
import MapRoutePoints from '../map/MapRoutePoints';




export function formatearFechaES(fecha) {
  const date = new Date(fecha);

  const fechaParte = new Intl.DateTimeFormat("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);

  const horaParte = new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

  return `${fechaParte} a las ${horaParte}`;
}

export function formatearHotaES(fecha) {
  const date = new Date(fecha);

  const horaParte = new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

  return `${horaParte}`;
}

const RouteMapDrawer = ({
  open,
  onClose,
  loading,
  positions,
  salidaId,
  deviceName,
  baseFrom,
  baseTo,
  offsetBeforeMin,
  offsetAfterMin,
  onExtendBefore,
  onExtendAfter,
  onResetRange,
}) => {

  const stablePositions = useMemo(() => positions, [positions]);

  const effectiveFrom = baseFrom
    ? moment(baseFrom).subtract(offsetBeforeMin, 'minutes').format('DD/MM/YYYY HH:mm')
    : null;
  const effectiveTo = baseTo
    ? moment(baseTo).add(offsetAfterMin, 'minutes').format('DD/MM/YYYY HH:mm')
    : null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      keepMounted
      PaperProps={{
        style: {
          width: '50vw',
          minWidth: '340px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        borderBottom: '1px solid #e0e0e0',
        background: '#163b61',
        color: '#fff',
        flexShrink: 0,
      }}>
        <span style={{ fontWeight: 600, fontSize: '0.95em' }}>
          {salidaId ? `Ruta — Salida #${salidaId}` : 'Ruta'}
        </span>
        <IconButton size="small" onClick={onClose} style={{ color: '#fff' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Body */}
      <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        {loading && (
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '12px',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 10,
          }}>
            <CircularProgress style={{ color: '#163b61' }} />
            <span style={{ color: '#163b61', fontWeight: 500 }}>Cargando ruta…</span>
          </div>
        )}

        {!loading && stablePositions.length === 0 && (
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '8px',
            color: '#888',
          }}>
            <MapIcon style={{ fontSize: 48, opacity: 0.3 }} />
            <span>Sin posiciones para esta salida</span>
          </div>
        )}

        <div style={{
          position: 'absolute',
          inset: 0,
          visibility: (!loading && stablePositions.length > 0) ? 'visible' : 'hidden',
        }}>
          <MapView>
            <MapGeofence />
            {stablePositions.length > 0 && (
              <>
                <MapRoutePath positions={stablePositions} lineWidth={6} />
                <MapCamera positions={stablePositions} />
              </>
            )}
          </MapView>
        </div>
      </div>

      {/* Footer */}
      {!loading && (
        <div style={{
          padding: '8px 16px',
          borderTop: '1px solid #e0e0e0',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          flexShrink: 0,
        }}>
          {/*
          {stablePositions.length > 0 && (
            <div style={{ fontSize: '0.8em', color: '#555', display: 'flex', gap: '16px' }}>
              <span>{stablePositions.length} posiciones</span>
              {deviceName && <span>{deviceName}</span>}
            </div>
          )}
          */}
          {effectiveFrom && effectiveTo && (
            <div style={{ fontSize: '0.75em', color: '#163b61', fontWeight: 500 }}>
              Rango consultado: {effectiveFrom} — {effectiveTo}
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
            <Button
              size="small"
              variant="outlined"
              onClick={onExtendBefore}
              disabled={loading}
            >
              + 10 min antes
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={onExtendAfter}
              disabled={loading}
            >
              + 10 min después
            </Button>
            {(offsetBeforeMin > 0 || offsetAfterMin > 0) && (
              <Button
                size="small"
                variant="text"
                onClick={onResetRange}
                disabled={loading}
              >
                Reiniciar rango
              </Button>
            )}
            {(offsetBeforeMin > 0 || offsetAfterMin > 0) && (
              <span style={{ fontSize: '0.75em', color: '#888' }}>
                (−{offsetBeforeMin} min / +{offsetAfterMin} min)
              </span>
            )}
          </div>
        </div>
      )}
    </Drawer>
  );
};

const DepartureEventsMapDrawer = ({
  open,
  onClose,
  loading,
  salida,
  positions,
  selectedIndex: externalSelectedIndex = null,
  onPositionSelect,
}) => {

  console.log("Salida in modal is ", salida)
  console.log("Positions in modal is ", positions)
  const hours12 = usePreference('twelveHourFormat');
  const [mapKey, setMapKey] = useState(0);
  const [isMapReady, setIsMapReady] = useState(false);
  const [shouldRenderMap, setShouldRenderMap] = useState(false);

  // Manejar la apertura/cierre del drawer
  useEffect(() => {
    if (open) {
      // Cuando se abre, renderiza el mapa después de un pequeño delay
      setShouldRenderMap(true);
      setTimeout(() => setIsMapReady(true), 200);
    } else {
      // Cuando se cierra, desmonta el mapa inmediatamente
      setIsMapReady(false);
      setShouldRenderMap(false);
      // Incrementa el key para forzar un nuevo montaje la próxima vez
      setMapKey(prev => prev + 1);
    }
  }, [open]);

  // Seleccionar siempre la primera posición si no hay selección
  useEffect(() => {
    if (positions.length > 0 && !selectedPosition && open) {
      onPositionSelect(0);
    }
  }, [positions.length, open]);

  const selectedPosition = useMemo(() => {
    if (externalSelectedIndex !== null && externalSelectedIndex !== undefined && positions[externalSelectedIndex]) {
      return positions[externalSelectedIndex];
    }
    return null;
  }, [externalSelectedIndex, positions]);

  const handlePositionClick = (position, index) => {
    if (onPositionSelect) {
      if (externalSelectedIndex === index) {
        onPositionSelect(null);
      } else {
        onPositionSelect(index);
      }
    }
  };

  const formatValue = (position, key) => {
    switch (key) {
      case 'fixTime':
        return formatTime(position[key], 'seconds', hours12);
      case 'latitude':
        return position.latitude?.toFixed(6);
      case 'longitude':
        return position.longitude?.toFixed(6);
      case 'speed':
        return position.speed ? `${(position.speed * 1.852).toFixed(1)} km/h` : '0 km/h';
      default:
        return position[key] || '';
    }
  };

  // Si no hay posiciones, mostrar el estado vacío
  if (!loading && positions.length === 0) {
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        keepMounted={false}
        PaperProps={{
          style: {
            width: '50vw',
            minWidth: '340px',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px',
          borderBottom: '1px solid #e0e0e0',
          background: '#163b61',
          color: '#fff',
          flexShrink: 0,
        }}>
          <span style={{ fontWeight: 600, fontSize: '0.95em' }}>
            {salida?.id ? `Ruta — Salida #${salida.id}` : 'Ruta'}
          </span>
          <IconButton size="small" onClick={onClose} style={{ color: '#fff' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '8px',
          color: '#888',
        }}>
          <MapIcon style={{ fontSize: 48, opacity: 0.3 }} />
          <span>Sin posiciones para esta salida</span>
        </div>
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      keepMounted={false}
      PaperProps={{
        style: {
          width: '50vw',
          minWidth: '340px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        borderBottom: '1px solid #e0e0e0',
        background: '#163b61',
        color: '#fff',
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontWeight: 600, fontSize: '0.95em' }}>
            {salida?.id ? `Ruta — Salida #${salida.id}` : 'Ruta'}
          </span>
          <span style={{ fontSize: '0.7em', opacity: 0.8 }}>
            {positions.length} posición{positions.length !== 1 ? 'es' : ''}
          </span>
        </div>
        <IconButton size="small" onClick={onClose} style={{ color: '#fff' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <div style={{
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        minHeight: '300px',
        width: '100%',
        backgroundColor: '#f5f5f5',
      }}>
        {loading && (
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '12px',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 10,
          }}>
            <CircularProgress style={{ color: '#163b61' }} />
            <span style={{ color: '#163b61', fontWeight: 500 }}>Cargando...</span>
          </div>
        )}


        {shouldRenderMap && !loading && positions.length > 0 && (
          <div style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
          }}>
            <MapView
              key={mapKey}
              onMapReady={() => setIsMapReady(true)}
              defaultZoom={10}
            >
              <MapGeofence />
              {selectedPosition && isMapReady && (
                <MapPositions
                  positions={[selectedPosition]}
                  titleField="fixTime"
                />
              )}
            </MapView>
            {selectedPosition && (
              <MapCamera
                latitude={selectedPosition.latitude}
                longitude={selectedPosition.longitude}
                defaultZoom={17}
              />
            )}
          </div>
        )}
      </div>

      {!loading && positions.length > 0 && (
        <div style={{
          borderTop: '1px solid #e0e0e0',
          flexShrink: 0,
          background: '#fff',
        }}>
          <div style={{
            padding: '12px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            maxHeight: '250px',
            overflow: 'auto',
          }}>
            {positions.map((position, index) => {
              const isSelected = externalSelectedIndex === index;
              const isFirst = index === 0;
              const isLast = index === positions.length - 1;

              const getEventType = () => {
                if (isFirst) return 'Entrada';
                if (isLast) return 'Salida';
                return '';
              };

              const getBadgeStyle = () => {
                return {
                  background: '#e3f2fd',
                  color: '#1565c0'
                };
              };

              const badgeStyle = getBadgeStyle();

              return (
                <div
                  key={`${position.id || position.latitude || index}-${index}`}
                  onClick={() => handlePositionClick(position, index)}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'auto 1fr auto',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: `2px solid ${isSelected ? '#163b61' : '#e8e8e8'}`,
                    background: isSelected ? '#f0f4fa' : '#fafafa',
                    cursor: 'pointer',
                    transition: 'all 0.25s ease',
                    position: 'relative',
                  }}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: isSelected ? '#163b61' : '#d0d0d0',
                    color: isSelected ? '#fff' : '#666',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    flexShrink: 0,
                  }}>
                    {isSelected ? (
                      <GpsFixedIcon style={{ fontSize: '18px', color: 'white' }} />
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </div>

                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(100px, auto) 1fr',
                    gap: '4px 16px',
                    minWidth: 0,
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      minWidth: '80px',
                    }}>
                      <span style={{
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        color: '#333',
                        whiteSpace: 'nowrap',
                      }}>
                        {formatValue(position, 'fixTime')}
                      </span>
                      <span style={{
                        fontSize: '0.7rem',
                        color: '#888',
                        marginTop: '1px',
                      }}>
                        {formatValue(position, 'speed')}
                      </span>
                    </div>

                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      minWidth: '120px',
                    }}>
                      <span style={{
                        fontSize: '0.95rem',
                        color: '#444',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}>
                        {salida?.triggeredTicket?.raw?.geofence || 'Sin geocerca'}
                      </span>
                      <span style={{
                        fontSize: '0.7rem',
                        color: '#999',
                        marginTop: '1px',
                        whiteSpace: 'nowrap',
                      }}>
                        {formatValue(position, 'latitude')}, {formatValue(position, 'longitude')}
                      </span>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '6px',
                    flexShrink: 0,
                  }}>
                    <span style={{
                      fontSize: '0.6rem',
                      padding: '3px 12px',
                      borderRadius: '12px',
                      background: badgeStyle.background,
                      color: badgeStyle.color,
                      fontWeight: 600,
                      whiteSpace: 'nowrap',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px',
                    }}>
                      {getEventType()}
                    </span>

                    <div style={{
                      color: isSelected ? '#163b61' : '#ddd',
                      transition: 'color 0.2s',
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                      {isSelected ? (
                        <CheckCircleIcon style={{ fontSize: '20px' }} />
                      ) : (
                        <CircleIcon style={{ fontSize: '16px' }} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Drawer>
  );
};
const TicketReportPage = () => {
  const navigate = useNavigate();
  const classes = useReportStyles();
  const t = useTranslation();
  const tableBodyRef = useRef(null);
  const rowRefs = useRef({});
  const activeRouteRequestRef = useRef(null);

  const devices = useSelector((state) => state.devices.items);
  const aheadTime = useAheadTimeThreshold();

  const atts_for_ui = useMergedTransportAtts();

  const [loading, setLoading] = useState(false);
  const [validity, setValidity] = useState(0);
  const [subusers, setSubusers] = useState([]);

  const calcValidity = (tickets) => ((tickets.reduce((acc, obj) => acc + (obj.enterTime ? 1 : 0), 0) * 100) / tickets.length) >= validity;


  // vars for remake
  const [uiSalidas, setUiSalidas] = useState({});
  const [routeName, setRouteName] = useState('');
  const [committing, setCommitting] = useState(false);
  const [committed, setCommitted] = useState(false);
  const [extraCharges, setExtraCharges] = useState([]);

  const [mapDrawer, setMapDrawer] = useState({
    open: false,
    positions: [],
    loading: false,
    salidaId: null,
    baseFrom: null,
    baseTo: null,
    deviceId: null,
    offsetBeforeMin: 0,
    offsetAfterMin: 0,
  });

  const [departureEventsDrawer, setDepartureEventsDrawer] = useState({
    open: false,
    loading: false,
    salida: null,
    positions: [],
    selectedIndex: null,
  });

  const handlePositionSelect = useCallback((index) => {
    setDepartureEventsDrawer(prev => ({
      ...prev,
      selectedIndex: index,
    }));
  }, []);

  const isPunishable = (ticket) =>
    (ticket.raw?.difference > 0 && ticket.raw?.punishment > 0) || (ticket.raw.progressPunishment > 0) || (ticket.raw.globalCostPunishment);

  const needsRecalculation = (ticket) =>
    ticket.raw?.enterTime === null || ticket.raw?.enterTime === undefined;

  const handleDownload = (url) => {
    // Disable the button and set loading state to true
    setLoading(true);

    // URL of the file to download
    const downloadUrl = url;

    // Create a new XMLHttpRequest
    const xhr = new XMLHttpRequest();

    // Handle completion of the download
    xhr.addEventListener('load', () => {
      // Once the download is complete, enable the button and reset loading state
      setLoading(false);

      // Handle the downloaded data
      const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

      // Create a blob URL for the downloaded file
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element for the download link
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'report.xlsx'; // Specify the desired file name
      document.body.appendChild(a);

      // Trigger a click event to start the download
      a.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(url);
    });

    // Handle any errors during the download
    xhr.addEventListener('error', () => {
      // Handle download error

      // Enable the button and reset loading state
      setLoading(false);
    });

    // Open the request and start the download
    xhr.open('GET', downloadUrl);
    xhr.responseType = 'blob'; // Set the response type to 'blob'
    xhr.send();
  };

  const handleSubmit = useCatch(async ({ deviceIds, groupIds, from, to, type, unify }) => {
    setRouteName('');
    setUiSalidas({});
    setExtraCharges([]);
    window.filters = { deviceIds, groupIds, from, to, type, unify };
    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);
    if (type === 'export') {
      handleDownload(`/api/reports/tickets/xlsx?${query.toString()}`);
      // window.location.assign(`/api/reports/tickets/xlsx?${query.toString()}`);
    } else if (type === 'mail') {
      const response = await fetch(`/api/reports/tickets/mail?${query.toString()}`);
      if (!response.ok) {
        throw Error(await response.text());
      }
    } else {
      await fetchTickets(query)
    }
  });

  const fetchTickets = async (query, resetSalidaId = null) => {
    setLoading(true);
    try {
      const response = await fetch(`/api/reports/tickets?${query.toString()}`, {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const items = await response.json();

        const uiData = buildUiSalidas(items, resetSalidaId !== null ? uiSalidas : null, resetSalidaId);
        setUiSalidas(uiData);
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }

  const handleSchedule = useCatch(async (deviceIds, groupIds, report) => {
    report.type = 'route';
    const error = await scheduleReport(deviceIds, groupIds, report);
    if (error) {
      throw Error(error);
    } else {
      navigate('/reports/scheduled');
    }
  });

  const fetchRoutePositions = async (salida, deviceId, baseFrom, baseTo, offsetBeforeMin, offsetAfterMin) => {
    activeRouteRequestRef.current = salida;

    setMapDrawer(prev => ({ ...prev, loading: true }));

    try {
      const from = moment(baseFrom).subtract(offsetBeforeMin, 'minutes').toISOString();
      const to = moment(baseTo).add(offsetAfterMin, 'minutes').toISOString();

      const query = new URLSearchParams({ from, to });
      query.append('deviceId', deviceId);

      const response = await fetch(`/api/reports/route?${query.toString()}`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(await response.text());

      const positions = await response.json();

      // Si mientras esperábamos se pidió otra ruta, descartamos esta respuesta
      if (activeRouteRequestRef.current !== salida) return;

      setMapDrawer(prev => ({
        ...prev,
        open: true,
        positions,
        loading: false,
        salidaId: salida,
        baseFrom,
        baseTo,
        deviceId,
        offsetBeforeMin,
        offsetAfterMin,
      }));
    } catch (err) {
      console.error('Error cargando ruta:', err);

      if (activeRouteRequestRef.current !== salida) return;

      setMapDrawer(prev => ({ ...prev, loading: false }));
      alert('No se pudo cargar la ruta');
    }
  };

  const handleVerRuta = (salida) => {
    const meta = uiSalidas[salida].meta;

    setMapDrawer({
      open: true,
      positions: [],
      loading: true,
      salidaId: salida,
      baseFrom: meta.date,
      baseTo: meta.endingDate,
      deviceId: meta.deviceId,
      offsetBeforeMin: 0,
      offsetAfterMin: 0,
    });

    fetchRoutePositions(salida, meta.deviceId, meta.date, meta.endingDate, 0, 0);
  };

  const handleSeeDepartureEvent = async (salida) => {
    const selectedSalida = uiSalidas[salida];
    const triggeredTicket = selectedSalida.tickets?.find(ticket => ticket.raw?.triggeredSalida === true);

    console.log("Selected salida is ", selectedSalida)
    console.log("Triggered ticket is ", triggeredTicket)

    setDepartureEventsDrawer({
      open: true,
      loading: true,
      salida: {
        ...selectedSalida
      },
      positions: [],
      selectedIndex: null,
    });

    if (!triggeredTicket) {
      setDepartureEventsDrawer({
        ...prev,
        loading: false,
      });
      return;
    }

    try {

      const ticketTime = triggeredTicket.raw.enterTime || triggeredTicket.raw.expectedTime;
      const ticketDate = new Date(ticketTime);


      const from = new Date(ticketDate.getTime() - 5 * 60 * 1000);
      const to = new Date(ticketDate.getTime() + 5 * 60 * 1000);

      const fromISO = from.toISOString();
      const toISO = to.toISOString();

      const deviceId = selectedSalida.meta?.deviceId || 0;

      const eventsResponse = await fetch(`/api/reports/events?from=${fromISO}&to=${toISO}&deviceId=${deviceId}&type=geofenceEnter&type=geofenceExit`, {
        headers: { Accept: 'application/json' },
      });

      if (!eventsResponse.ok) {
        throw Error(await eventsResponse.text());
      }

      const events = await eventsResponse.json();

      console.log("Events are ", events)

      const entryExitEvents = events.filter(event =>
        event.geofenceId == selectedSalida.meta.geofenceId &&
        (event.type === 'geofenceEnter' ||
          event.type === 'geofenceExit')
      );

      const positionPromises = entryExitEvents
        .filter(event => event.positionId)
        .map(async (event) => {
          try {
            const posResponse = await fetch(`/api/positions?id=${event.positionId}`);
            if (posResponse.ok) {
              const positions = await posResponse.json();
              return positions[0];
            }
            return null;
          } catch (error) {
            console.error('Error fetching position:', error);
            return null;
          }
        });

      const positions = (await Promise.all(positionPromises))
        .filter(pos => pos !== null);

      console.log("Positions are ", positions)

      const eventsWithPositions = entryExitEvents.map(event => ({
        ...event,
        position: positions.find(pos => pos.id === event.positionId) || null
      }));


      setDepartureEventsDrawer({
        open: true,
        loading: false,
        salida: {
          id: salida,
          ...selectedSalida,
          triggeredTicket: triggeredTicket,
        },
        positions: positions.length > 0 ? positions : simulatedPositions,
        selectedIndex: null,
      });

    } catch (error) {
      console.error('Error fetching events and positions:', error);

      setDepartureEventsDrawer(prev => ({
        ...prev,
        loading: false,
      }));
    }
  };
  const handleExtendRouteBefore = () => {
    const newOffset = mapDrawer.offsetBeforeMin + 10;
    fetchRoutePositions(
      mapDrawer.salidaId,
      mapDrawer.deviceId,
      mapDrawer.baseFrom,
      mapDrawer.baseTo,
      newOffset,
      mapDrawer.offsetAfterMin
    );
  };

  const handleExtendRouteAfter = () => {
    const newOffset = mapDrawer.offsetAfterMin + 10;
    fetchRoutePositions(
      mapDrawer.salidaId,
      mapDrawer.deviceId,
      mapDrawer.baseFrom,
      mapDrawer.baseTo,
      mapDrawer.offsetBeforeMin,
      newOffset
    );
  };

  const handleResetRouteRange = () => {
    fetchRoutePositions(
      mapDrawer.salidaId,
      mapDrawer.deviceId,
      mapDrawer.baseFrom,
      mapDrawer.baseTo,
      0,
      0
    );
  };

  const reload = async ({ id }) => {
    let { deviceIds, groupIds, from, to, type, unify } = window.filters;
    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);

    Notiflix.Loading.dots('Actualizando', { backgroundColor: 'rgba(0,0,0,1)' });
    await fetchTickets(query, id);
    // rowRefs.current[id]?.scrollIntoView({ behaviour: 'smooth', block: 'center' });
    setTimeout(() => {
      try {
        rowRefs.current[id].start.scrollIntoViewIfNeeded();
      } catch (error) {

      }
      Notiflix.Loading.remove();
    }, 500);
  }

  const buildUiSalidas = (apiItems, previousUiSalidas = null, resetSalidaId = null) => {
    return apiItems.reduce((acc, obj) => {
      const salidaId = obj.salida;
      const isResetTarget = String(salidaId) === String(resetSalidaId);
      const prevSalida = (previousUiSalidas && !isResetTarget) ? previousUiSalidas[salidaId] : null;

      if (!acc[salidaId]) {
        const isLocked = obj.s.receiptId > 0;

        acc[salidaId] = {
          id: salidaId,
          // Se conserva la selección previa del usuario, salvo para la salida
          // que fue recalculada (isResetTarget) o si tiene recibo ya generado.
          processingState: (prevSalida && !isLocked)
            ? prevSalida.processingState
            : (isLocked ? 'locked' : 'ignored'),
          omitReason: (prevSalida && !isLocked)
            ? prevSalida.omitReason
            : (obj.s.excuse || ''),
          meta: obj.s,
          receipt: obj.r,
          tickets: [],
          locked: isLocked,
          computedNotes: []
        };
      }

      const prevTicket = prevSalida?.tickets?.find(pt => pt.id === obj.id);

      acc[salidaId].tickets.push({
        id: obj.id,
        raw: obj,
        forgiven: prevTicket ? prevTicket.forgiven : ((obj.excuse && obj.excuse !== '') ? true : false),
        excuse: prevTicket ? prevTicket.excuse : (obj.excuse || ''),
        marginBeforeMin: prevTicket ? prevTicket.marginBeforeMin : 5,
        marginAfterMin: prevTicket ? prevTicket.marginAfterMin : 5,
        recalcNotFound: prevTicket ? prevTicket.recalcNotFound : false,
      });

      if (obj.progressPunishment && obj.progressPunishment > 0) {
        acc[salidaId].computedNotes.push(`Se aplica cobro por adelanto en el ticket de el dia ${formatearFechaES(obj.expectedTime)} ${obj.punishment} -> ${obj.progressPunishment}`);
      }

      if (obj.globalCostPunishment && obj.globalCostPunishment > 0) {
        acc[salidaId].computedNotes.push(`Se aplica cobro cuota global en el ticket de el dia ${formatearFechaES(obj.expectedTime)} ${obj.punishment} -> ${obj.globalCostPunishment}`);
      }

      return acc;
    }, {});
  };

  const updateSalidaOmitReason = (salidaId, reason) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        omitReason: reason,
      },
    }));
  };

  const setSalidaState = (salidaId, state) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        processingState: state,
        omitReason: state === 'omitted' ? prev[salidaId].omitReason : '',
      },
    }));
  };

  const updateTicketExcuse = (salidaId, ticketId, excuse) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        tickets: prev[salidaId].tickets.map(t =>
          t.id === ticketId
            ? {
              ...t,
              excuse,
              forgiven: (excuse || '').trim().length > 0,
            }
            : t
        ),
      },
    }));
  };

  const recalculateTicket = async (salidaId, ticketId) => {
    const currentTicket = uiSalidas[salidaId]?.tickets.find(t => t.id === ticketId);
    const marginBeforeMin = currentTicket?.marginBeforeMin ?? 5;
    const marginAfterMin = currentTicket?.marginAfterMin ?? 5;

    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        tickets: prev[salidaId].tickets.map(t =>
          t.id === ticketId ? { ...t, recalculating: true, recalcNotFound: false } : t
        ),
      },
    }));

    try {
      const response = await fetch('/api/tickets/recalculate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: ticketId, marginBeforeMin, marginAfterMin }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      const { found, tickets: refreshedTickets } = await response.json();

      if (!found) {
        // No hubo evento ni posición dentro del margen configurado.
        // Se deja el ticket como estaba y se habilita el ajuste de margen para reintentar.
        setUiSalidas(prev => ({
          ...prev,
          [salidaId]: {
            ...prev[salidaId],
            tickets: prev[salidaId].tickets.map(t =>
              t.id === ticketId ? { ...t, recalculating: false, recalcNotFound: true } : t
            ),
          },
        }));
        return;
      }

      // updateSalida en el backend puede haber recalculado varios tickets de la
      // misma salida (por el ajuste de expectedTime/tolerancias), no solo el elegido.
      const byId = Object.fromEntries(refreshedTickets.map(rt => [rt.id, rt]));

      setUiSalidas(prev => ({
        ...prev,
        [salidaId]: {
          ...prev[salidaId],
          tickets: prev[salidaId].tickets.map(t =>
            byId[t.id]
              ? {
                ...t,
                raw: { ...t.raw, ...byId[t.id] },
                recalculating: false,
                recalcNotFound: false,
              }
              : t
          ),
        },
      }));
    } catch (error) {
      console.error('Recalculation failed:', error);
      setUiSalidas(prev => ({
        ...prev,
        [salidaId]: {
          ...prev[salidaId],
          tickets: prev[salidaId].tickets.map(t =>
            t.id === ticketId ? { ...t, recalculating: false } : t
          ),
        },
      }));
    }
  };

  const getTicketPunishment = (t) => {
    if (!isPunishable(t)) return 0;
    if (t.forgiven) return 0;
    if (t.raw.progressPunishment > 0) return Number(t.raw.progressPunishment);
    if (t.raw.globalCostPunishment) return Number(t.raw.globalCostPunishment);
    return Number(t.raw.punishment) || 0;
  };

  const addExtraCharge = () => {
    setExtraCharges(prev => [
      ...prev,
      { id: v4(), description: '', amount: 0 }
    ]);
  };

  const updateExtraCharge = (id, field, value) => {
    setExtraCharges(prev =>
      prev.map(c =>
        c.id === id
          ? { ...c, [field]: field === 'amount' ? Number(value) : value }
          : c
      )
    );
  };

  const removeExtraCharge = (id) => {
    setExtraCharges(prev => prev.filter(c => c.id !== id));
  };

  const sanitizedExtraCharges = extraCharges.filter(
    c => c.description.trim() !== '' && Number(c.amount) > 0
  );


  const getExtraChargesTotal = () => {
    return sanitizedExtraCharges.reduce(
      (sum, c) => sum + (Number(c.amount) || 0),
      0
    );
  };

  const getSalidaTotal = (salida) => {
    if (salida.processingState !== 'included') return 0;
    if (salida.meta.receiptId > 0) return 0;

    return salida.tickets.reduce(
      (sum, t) => sum + getTicketPunishment(t),
      0
    );
  };


  const getGlobalTotal = (uiSalidas) =>
    Object.values(uiSalidas).reduce(
      (sum, salida) => sum + getSalidaTotal(salida),
      0
    ) + getExtraChargesTotal();

  const getOmittedSalidas = (uiSalidas) =>
    Object.values(uiSalidas)
      .filter(s => s.processingState === 'omitted')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date
      }));

  const getChargeableSalidas = (uiSalidas) =>
    Object.values(uiSalidas)
      .filter(s => s.processingState === 'included')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date
      }));

  const getExcusedTickets = (uiSalidas, options = {}) => {
    const {
      mode = 'current', // 'current' | 'receipt'
      receiptId = null,
    } = options;

    return Object.values(uiSalidas)
      .filter(salida => {
        if (mode === 'current') {
          // Only salidas being processed right now
          return salida.processingState === 'included' ||
            salida.processingState === 'omitted';
        }

        if (mode === 'receipt') {
          // Only salidas belonging to that receipt
          return salida.meta.receiptId === receiptId;
        }

        return false;
      })
      .flatMap(salida =>
        salida.tickets
          .filter(t => t.forgiven && t.excuse !== '')
          .map(t => ({
            salidaId: salida.id,
            ticketId: t.id,
            excuse: t.excuse,
            punishment: t.raw.punishment,
          }))
      );
  };

  const buildReceiptData = () => {
    return {
      routeName,
      // date: new Date().toLocaleString(),
      date: new Date().toISOString(),
      salidas: Object.values(uiSalidas)
        // .filter(s => s.included)
        .filter(s => s.processingState === 'included')
        .map(s => ({
          id: s.id,
          total: getSalidaTotal(s),
          date: s.meta.date,
          counter1In: s.meta.counter1In ?? 0,
          counter1Out: s.meta.counter1Out ?? 0,
          counter2In: s.meta.counter2In ?? 0,
          counter2Out: s.meta.counter2Out ?? 0,
          tickets: s.tickets.map(t => ({
            id: t.id,
            device: devices[t.raw.device]?.name,
            geofence: t.raw.geofence,
            expectedTime: t.raw.expectedTime,
            enterTime: t.raw.enterTime,
            difference: t.raw.difference,
            punishment: t.raw.punishment,
            forgiven: t.forgiven,
            excuse: t.excuse,
            progressPunishment: t.raw.progressPunishment,
            globalCostPunishment: t.raw.globalCostPunishment
          })),
          computedNotes: s.computedNotes
        })),
      omittedSalidas: getOmittedSalidas(uiSalidas),
      excusedTickets: getExcusedTickets(uiSalidas, {
        mode: 'current',
      }),
      extraCharges: sanitizedExtraCharges,
      extraChargesTotal: getExtraChargesTotal(),
      // extraChargesSerialized: JSON.stringify(sanitizedExtraCharges),
      globalTotal: getGlobalTotal(uiSalidas),
    };
  };

  const printReceipt = (receiptData, simplify = true) => {
    const win = window.open('', '_blank');


    const data = !simplify ? receiptData : {
      ...receiptData, salidas: receiptData.salidas.filter(salida =>
        salida.total > 0 ||
        salida.tickets.some(ticket => ticket.excuse && ticket.excuse.trim() !== '')
      )
    };
    console.log({ data, atts_for_ui });

    win.document.write(
      renderToStaticMarkup(
        <ReceiptPrintView data={{ ...data, atts_for_ui }} />
      )
    );
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  // const printReceiptThermal = (receiptData) => {
  //   const win = window.open('', '_blank');
  //   win.document.write(renderToStaticMarkup(<ReceiptPrintViewThermal data={receiptData} />));
  //   win.document.close();
  //   win.focus();
  //   win.print();
  //   win.close();
  // };

  const printReceiptThermal = (receiptData) => {
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('El navegador bloqueó la ventana de impresión');
      return;
    }
    console.log({ receiptData });

    const html = renderToStaticMarkup(
      <ReceiptPrintViewThermal data={{ ...receiptData, atts_for_ui }} />
    );

    printWindow.document.write(`
    <html>
      <head>
        <title>Receipt</title>
        <style>
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>
        ${html}
      </body>
    </html>
  `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();

        // Opcional
        // printWindow.close();
      }, 500);
    };
  };

  const validateBeforeCommit = () => {
    // if (!routeName.trim()) {
    //   throw new Error('El nombre de la ruta es obligatorio');
    // }

    const omitted = getOmittedSalidas(uiSalidas);
    const missingReasons = omitted.filter(o => !o.reason?.trim());

    if (missingReasons.length > 0) {
      throw new Error('Todas las salidas omitidas deben tener un motivo');
    }

    if (getGlobalTotal(uiSalidas) < 0) {
      throw new Error('El total no es válido');
    }
  };

  const refetchWithCurrentFilters = async () => {
    const { deviceIds, groupIds, from, to, unify } = window.filters || {};
    if (!deviceIds || !groupIds) return;

    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);

    await fetchTickets(query);
  };

  const commitAndPrint = async () => {
    try {
      validateBeforeCommit();

      setCommitting(true);

      const receiptData = buildReceiptData();

      const response = await fetch('/api/tickets/commit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(receiptData),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      const commitResult = await response.json();

      setCommitted(true);

      // Print only after commit succeeds
      printReceiptThermal({
        ...receiptData,
        commitId: commitResult.commitId,
        committedAt: commitResult.storedAt,
        date: commitResult.storedAt,
      });
      await refetchWithCurrentFilters();
    } catch (err) {
      console.log(err);

      alert(err.message);
    } finally {
      setCommitting(false);
    }
  };

  const getReceiptsMap = (uiSalidas) =>
    Object.values(uiSalidas).reduce((acc, s) => {
      const rid = s.meta.receiptId;
      if (!rid || rid <= 0) return acc;

      if (!acc[rid]) acc[rid] = [];
      acc[rid].push(s);
      return acc;
    }, {});

  const buildReceiptDataFromReceiptId = (receiptId) => {
    const salidas = Object.values(uiSalidas)
      .filter(s => s.meta.receiptId === receiptId);

    const omittedSalidas = salidas
      .filter(s => s.omitReason !== '')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date,
        ...s
      }));

    const omittedIds = omittedSalidas.map(s => s.id);

    const excusedTickets = getExcusedTickets(uiSalidas, {
      mode: 'receipt',
      receiptId,
    });

    const chargeableSalidas = salidas.filter(s => s.locked).filter(s => !omittedIds.includes(s.id));

    const getSalidaTotal = (salida) => {
      return salida.tickets.reduce(
        (sum, t) => sum + getTicketPunishment(t),
        0
      );
    };


    const globalTotal = chargeableSalidas.reduce(
      (sum, s) => sum + getSalidaTotal(s), 0
    );

    const otherCharges = JSON.parse(salidas[0].receipt.otherCharges || '[]');

    const getExtraChargesTotal = () => {
      return otherCharges.reduce(
        (sum, c) => sum + (Number(c.amount) || 0),
        0
      );
    };

    return {
      routeName: routeName || '',
      date: new Date(salidas.at(0).receipt.storedAt).toISOString(),
      commitId: receiptId,
      salidas: chargeableSalidas
        .map(s => ({
          id: s.id,
          total: getSalidaTotal(s),
          date: s.meta.date,

          counter1In: s.meta.counter1In ?? 0,
          counter1Out: s.meta.counter1Out ?? 0,
          counter2In: s.meta.counter2In ?? 0,
          counter2Out: s.meta.counter2Out ?? 0,
          tickets: s.tickets.map(t => ({
            id: t.id,
            device: devices[t.raw.device]?.name,
            geofence: t.raw.geofence,
            expectedTime: t.raw.expectedTime,
            enterTime: t.raw.enterTime,
            difference: t.raw.difference,
            punishment: t.raw.punishment,
            forgiven: t.forgiven,
            excuse: t.excuse,
            progressPunishment: t.raw.progressPunishment,
            globalCostPunishment: t.raw.globalCostPunishment
          })),
          computedNotes: s.computedNotes
        })),
      omittedSalidas,
      excusedTickets,
      extraCharges: otherCharges,
      extraChargesTotal: getExtraChargesTotal(),
      globalTotal: (globalTotal + getExtraChargesTotal()),
    };
  };

  const includeAllSalidas = () => {
    setUiSalidas(prev => {
      const updated = {};
      Object.keys(prev).forEach((salidaId) => {
        const salida = prev[salidaId];
        updated[salidaId] = salida.locked
          ? salida
          : { ...salida, processingState: 'included', omitReason: '' };
      });
      return updated;
    });
  };

  const ignoreAllSalidas = () => {
    setUiSalidas(prev => {
      const updated = {};
      Object.keys(prev).forEach((salidaId) => {
        const salida = prev[salidaId];
        updated[salidaId] = salida.locked
          ? salida
          : { ...salida, processingState: 'ignored', omitReason: '' };
      });
      return updated;
    });
  };

  const omitted = getOmittedSalidas(uiSalidas);
  const excused = getExcusedTickets(uiSalidas, {
    mode: 'current',
  });
  const chargeable = getChargeableSalidas(uiSalidas);
  const receiptsMap = getReceiptsMap(uiSalidas);

  useEffect(() => {
    // Attach the function to the global window object
    window.rowRefs = rowRefs;

    // Clean up the function when the component unmounts
    return () => {
      delete window.rowRefs;
    };
  }, []);

  useEffectAsync(async () => {
    const _subusers = await (await fetch('/api/subusers')).json();
    setSubusers(_subusers);

  }, []);

  useEffect(() => {
    let ticking = false;

    const tableBodyNode = tableBodyRef.current?.parentNode?.parentNode;
    if (tableBodyNode) {
      const handleScroll = (_) => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            ticking = false;
          });

          ticking = true;
        }
      };

      tableBodyNode.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        tableBodyNode.removeEventListener('scroll', handleScroll, { passive: true });
      };
    }
    return () => null;
  }, [tableBodyRef]);

  useEffect(() => {

  }, [routeName, uiSalidas]);

  const updateTicketMargin = (salidaId, ticketId, field, value) => {
    const numeric = Math.max(0, Number(value) || 0);
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        tickets: prev[salidaId].tickets.map(t =>
          t.id === ticketId ? { ...t, [field]: numeric } : t
        ),
      },
    }));
  };


  return (
    <PageLayout menu={< ReportsMenu />} breadcrumbs={['reportTitle', 'reportRoute']} >
      <div className={classes.container}>
        <div className={classes.containerMain}>
          <div className={classes.header}>
            <ReportFilter
              handleSubmit={handleSubmit}
              handleSchedule={handleSchedule}
              customDayOnly={true}
            >
              <FormControl style={{ width: '20vw' }}>
                <InputLabel>%</InputLabel>
                <Select
                  label="%"
                  value={validity}
                  onChange={(event) => setValidity(event.target.value)}
                >
                  <MenuItem key={`k-validity-${0}`} value={0}>-- Sin filtrar --</MenuItem>
                  <MenuItem key={`k-validity-${10}`} value={10}>10</MenuItem>
                  <MenuItem key={`k-validity-${20}`} value={20}>20</MenuItem>
                  <MenuItem key={`k-validity-${30}`} value={30}>30</MenuItem>
                  <MenuItem key={`k-validity-${40}`} value={40}>40</MenuItem>
                  <MenuItem key={`k-validity-${50}`} value={50}>50</MenuItem>
                  <MenuItem key={`k-validity-${60}`} value={60}>60</MenuItem>
                  <MenuItem key={`k-validity-${70}`} value={70}>70</MenuItem>
                  <MenuItem key={`k-validity-${80}`} value={80}>80</MenuItem>
                  <MenuItem key={`k-validity-${90}`} value={90}>90</MenuItem>
                  <MenuItem key={`k-validity-${100}`} value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </ReportFilter>
          </div>

          <br />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '12px' }}>
            <Button
              variant="outlined"
              onClick={ignoreAllSalidas}
              disabled={Object.keys(uiSalidas).length === 0}
            >
              Ignorar todo
            </Button>
            <Button
              variant="outlined"
              onClick={includeAllSalidas}
              disabled={Object.keys(uiSalidas).length === 0}
            >
              Incluir todo
            </Button>
          </div>
          <input
            type="text"
            placeholder="Nombre de la ruta"
            value={routeName}
            onChange={(e) => setRouteName(e.target.value)}
            style={{
              width: '800px',          // or '50%' or whatever you prefer
              maxWidth: '100%',
              padding: '8px',
              margin: '0 auto 16px auto',  // ← centers horizontally
              display: 'block',            // ← required for margin auto to work
              borderRadius: '6px',
              border: '1px solid #ccc',
            }}
          />


          {(isMobile() === true) ? (
            !loading ? Object.keys(uiSalidas).filter((salida) => calcValidity(uiSalidas[salida].tickets.map(t => t.raw))).map((salida) => (
              <>
                <div style={{ marginBottom: '2vh' }} />
                <TableExitsReport
                  data={{
                    ...uiSalidas[salida],
                    ticket: uiSalidas[salida].tickets.map(t => t.raw),
                    s: uiSalidas[salida].meta,
                  }}
                />

                <div style={{ marginBottom: '5vh' }} />
              </>
            )) : (
              <div style={{
                width: '100vw',
                height: '100vh',
                position: 'relative',
              }}
              >
                <ClimbingBoxLoader
                  style={{
                    width: '50%',
                    height: '50%',
                    position: 'absolute',
                    top: '0%',
                    left: '30%',
                    margin: '-25px 0 0 -25px',
                  }}
                  color="#000000"
                  loading={loading}
                  cssOverride={{}}
                  size={10}
                  aria-label="Cargando información"
                  data-testid="loader"
                />
              </div>
            )
          ) : (
            <Table>
              <TableHead>
                <TableRow key='headers'>
                  <TableCell className={classes.columnAction} />
                  <TableCell>{t('sharedDevice')}</TableCell>
                  <TableCell>{t('sharedGeofence')}</TableCell>
                  <TableCell>{t('groupParent')}</TableCell>
                  <TableCell>Hora programada</TableCell>
                  <TableCell>Hora de ingreso</TableCell>
                  <TableCell>Diferencia</TableCell>
                  <TableCell>Castigo</TableCell>
                  <TableCell>Excusa</TableCell>
                  <TableCell>Total salida</TableCell>
                </TableRow>
              </TableHead>

              <TableBody
                ref={tableBodyRef}
              >
                {!loading ? Object.keys(uiSalidas).filter((salida) => calcValidity(uiSalidas[salida].tickets.map(t => t.raw))).map((salida) => {
                  const isIncluded = uiSalidas[salida].included;
                  const hasReceipt = uiSalidas[salida].meta.receiptId > 0;
                  const receipt = uiSalidas[salida].meta.receiptId;
                  const isLocked = uiSalidas[salida].locked;

                  return (
                    <React.Fragment key={`fragment-salida-${salida}`}>

                      <TableRow key={`salida-${salida}`} ref={el => rowRefs.current[salida] = { start: el }}  >
                        <TableCell colSpan={2}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {!isLocked && (
                              <div style={{ display: 'flex', gap: '12px' }}>
                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'included'}
                                    onChange={() => setSalidaState(salida, 'included')}
                                  />
                                  Incluir
                                </label>

                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'omitted'}
                                    onChange={() => setSalidaState(salida, 'omitted')}
                                  />
                                  Omitir
                                </label>

                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'ignored'}
                                    onChange={() => setSalidaState(salida, 'ignored')}
                                  />
                                  Ignorar
                                </label>
                              </div>
                            )}

                            {`Salida: ${salida}`}
                            {hasReceipt && (
                              <span style={{ color: '#a00', marginLeft: '8px' }}>
                                (ya cobrada – recibo #{receipt})
                              </span>
                            )}

                          </label>

                        </TableCell>

                        <TableCell colSpan={2}>
                          {`Salida generada el ${formatearFechaES(uiSalidas[salida].meta.date)}`}
                        </TableCell>

                        {(uiSalidas[salida].meta.modifiedBy > 0) ? (
                          <TableCell colSpan={2}>
                            {`La hora fue modificada por el sub-usuario: ${uiSalidas[salida].meta.modifiedBy} - ${subusers.find((su) => su.id === uiSalidas[salida].meta.modifiedBy)?.name} el dia: ${new Date(uiSalidas[salida].meta.modifiedWhen).toLocaleString()}`}
                          </TableCell>
                        ) : <TableCell colSpan={2} />}

                        <TableCell colSpan={2} className="no-print" >
                          <TimeUpdateBtn
                            id={salida}
                            subusers={subusers}
                            callback={reload}
                          />
                        </TableCell>

                        {
                          atts_for_ui.seeTicketsRouteReport && (
                            <TableCell colSpan={1} className="no-print" >

                              <Button
                                variant="outlined"
                                size="medium"
                                startIcon={<MapIcon />}
                                onClick={() => handleVerRuta(salida)}

                              >
                                Ver ruta
                              </Button>
                            </TableCell>
                          )
                        }


                        {
                          atts_for_ui.seeTicketsDepartureReport && (

                            <TableCell colSpan={1} className="no-print" >
                              <Button
                                variant="outlined"
                                size="medium"
                                startIcon={<History />}
                                onClick={() => handleSeeDepartureEvent(salida)}

                              >
                                Eventos de salida
                              </Button>
                            </TableCell>
                          )
                        }


                        <TableCell colSpan={2}>
                          <strong>${getSalidaTotal(uiSalidas[salida]).toFixed(2)}</strong>
                        </TableCell>

                      </TableRow>
                      {(
                        uiSalidas[salida].processingState === 'omitted' ||
                        (
                          uiSalidas[salida].processingState === 'locked' &&
                          uiSalidas[salida].omitReason !== ''
                        )
                      ) && (
                          <TableRow key={`omit-salida-${salida}`}>
                            <TableCell colSpan={8}>
                              <input
                                type="text"
                                placeholder="Motivo de omisión"
                                value={uiSalidas[salida].omitReason}
                                onChange={(e) =>
                                  updateSalidaOmitReason(salida, e.target.value)
                                }
                                disabled={uiSalidas[salida].processingState === 'locked'}
                                style={{
                                  width: '100%',
                                  padding: '8px',
                                  borderRadius: '6px',
                                  border: '1px solid #ccc',
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        )}


                      {uiSalidas[salida].tickets.map((t) => {
                        const item = t.raw;
                        const isForgiven = t.forgiven === true;

                        return (
                          <TableRow
                            key={`tickets-salida-${salida}-ticket-${t.id}`}
                            className="print-data-row"
                            style={{
                              ...calcDiffColor(item, atts_for_ui),
                              opacity: isForgiven ? 0.6 : 1,
                            }}
                          >
                            <TableCell className={classes.columnAction} padding="none" />
                            <TableCell>
                              {devices[item.device]?.name}
                            </TableCell>
                            <TableCell>
                              {item.geofence}
                            </TableCell>
                            <TableCell>
                              {item.group}
                            </TableCell>
                            <TableCell>
                              {item.expectedTime ? formatDate(new Date(item.expectedTime), 'yyyy-MM-dd HH:mm:ss') : 'Sin registro'}
                            </TableCell>
                            <TableCell>
                              {needsRecalculation(t) ? (
                                t.recalcNotFound ? (
                                  <Stack spacing={0.5} sx={{ minWidth: 190 }}>
                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                      <ErrorOutline color="error" sx={{ fontSize: 14 }} />
                                      <Typography variant="caption" color="error">
                                        Sin datos en el margen
                                      </Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                      <Typography variant="caption" color="text.secondary">-</Typography>
                                      <Tooltip title="Minutos antes de la hora programada">
                                        <TextField
                                          type="number"
                                          size="small"
                                          variant="standard"
                                          value={t.marginBeforeMin}
                                          onChange={(e) => updateTicketMargin(salida, t.id, 'marginBeforeMin', e.target.value)}
                                          inputProps={{ min: 0, style: { textAlign: 'center', width: 32 } }}
                                        />
                                      </Tooltip>
                                      <Typography variant="caption" color="text.secondary">/</Typography>
                                      <Typography variant="caption" color="text.secondary">+</Typography>
                                      <Tooltip title="Minutos después de la hora programada">
                                        <TextField
                                          type="number"
                                          size="small"
                                          variant="standard"
                                          value={t.marginAfterMin}
                                          onChange={(e) => updateTicketMargin(salida, t.id, 'marginAfterMin', e.target.value)}
                                          inputProps={{ min: 0, style: { textAlign: 'center', width: 32 } }}
                                        />
                                      </Tooltip>
                                      <Typography variant="caption" color="text.secondary">min</Typography>
                                    </Stack>

                                    <Button
                                      size="small"
                                      variant="outlined"
                                      startIcon={<RefreshOutlined sx={{ fontSize: 14 }} />}
                                      disabled={t.recalculating}
                                      onClick={() => recalculateTicket(salida, t.id)}
                                      sx={{ alignSelf: 'flex-start', py: 0.25 }}
                                    >
                                      {t.recalculating ? 'Recalculando…' : 'Reintentar'}
                                    </Button>
                                  </Stack>
                                ) : (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    disabled={t.recalculating}
                                    onClick={() => recalculateTicket(salida, t.id)}
                                  >
                                    {t.recalculating ? 'Recalculando…' : 'Recalcular'}
                                  </Button>
                                )
                              ) : (
                                item.enterTime
                                  ? formatDate(new Date(item.enterTime), 'yyyy-MM-dd HH:mm:ss')
                                  : 'Sin registro'
                              )}
                            </TableCell>

                            <TableCell>
                              {item.difference}
                            </TableCell>
                            <TableCell style={{ ...(isForgiven ? { textDecoration: 'line-through' } : {}) }}>
                              {(item.progressPunishment > 0 ? item.progressPunishment : (item.globalCostPunishment > 0 ? item.globalCostPunishment : (item.difference > 0 ? item.punishment : 0)))}
                            </TableCell>
                            <TableCell>
                              {isPunishable(t) ? (
                                <input
                                  type="text"
                                  placeholder="Excusa"
                                  value={t.excuse}
                                  onChange={(e) =>
                                    updateTicketExcuse(salida, t.id, e.target.value)
                                  }
                                  disabled={isLocked}
                                  style={{
                                    width: '100%',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                  }}
                                />
                              ) : (
                                <span style={{ opacity: 0.5 }}>—</span>
                              )}
                            </TableCell>

                            {
                              atts_for_ui.seeTicketsRouteReport && (
                                <TableCell></TableCell>
                              )
                            }

                            {
                              atts_for_ui.seeTicketsDepartureReport && (
                                <TableCell></TableCell>
                              )
                            }


                          </TableRow>
                        )
                      })}

                      {/* Resumen contador */}
                      {atts_for_ui.seeTicketsPassangerCounterReport && (
                        <TableRow key={`counters-salida-${salida}`}>
                          <TableCell colSpan={12}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85em' }}>
                              <thead>
                                <tr>
                                  <th style={{ textAlign: 'left', padding: '4px 8px' }}></th>
                                  <th style={{ textAlign: 'center', padding: '4px 8px' }}>Subieron</th>
                                  <th style={{ textAlign: 'center', padding: '4px 8px' }}>Bajaron</th>
                                  <th style={{ textAlign: 'center', padding: '4px 8px' }}>En unidad</th>
                                </tr>
                              </thead>
                              <tbody>
                                {[
                                  {
                                    label: 'Puerta 1',
                                    inn: uiSalidas[salida].meta.counter1In ?? 0,
                                    out: uiSalidas[salida].meta.counter1Out ?? 0,
                                  },
                                  {
                                    label: 'Puerta 2',
                                    inn: uiSalidas[salida].meta.counter2In ?? 0,
                                    out: uiSalidas[salida].meta.counter2Out ?? 0,
                                  },
                                  {
                                    label: 'Total',
                                    inn: (uiSalidas[salida].meta.counter1In ?? 0) + (uiSalidas[salida].meta.counter2In ?? 0),
                                    out: (uiSalidas[salida].meta.counter1Out ?? 0) + (uiSalidas[salida].meta.counter2Out ?? 0),
                                    isTotal: true,
                                  },
                                ].map(({ label, inn, out, isTotal }) => (
                                  <tr key={label} style={isTotal ? { fontWeight: 'bold', borderTop: '1px solid #ccc' } : {}}>
                                    <td style={{ padding: '4px 8px' }}>{label}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px', color: '#065f46' }}>{inn}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px', color: '#ff185d' }}>{out}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px' }}>{inn - out}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </TableCell>
                        </TableRow>
                      )}
                      {/* Notas */}
                      <TableRow key={`salida-${salida}-end`} ref={el => (rowRefs.current[salida].end = el)}>
                        <TableCell colSpan={12}>
                          <List dense>
                            {uiSalidas[salida].computedNotes.map((note, index) => (
                              <ListItem key={index}>
                                <ListItemIcon>
                                  <InfoOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={note} />
                              </ListItem>
                            ))}
                          </List>
                        </TableCell>
                      </TableRow>

                    </React.Fragment>);
                }) : (
                  <TableShimmer columns={10} startAction />
                )}
              </TableBody>
            </Table>
          )}


          <div style={{ marginTop: '24px' }}>
            <strong>Cargos adicionales:</strong>

            {extraCharges.map(charge => (
              <div
                key={charge.id}
                style={{
                  display: 'flex',
                  gap: '8px',
                  marginBottom: '8px',
                  alignItems: 'center',
                }}
              >
                <input
                  type="text"
                  placeholder="Descripción"
                  value={charge.description}
                  onChange={(e) =>
                    updateExtraCharge(charge.id, 'description', e.target.value)
                  }
                  style={{
                    flex: 2,
                    padding: '6px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                  }}
                />

                <input
                  type="number"
                  placeholder="Monto"
                  value={charge.amount}
                  onChange={(e) =>
                    updateExtraCharge(charge.id, 'amount', e.target.value)
                  }
                  onWheel={(e) => e.target.blur()}
                  style={{
                    flex: 1,
                    padding: '6px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                  }}
                />

                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => removeExtraCharge(charge.id)}
                >
                  X
                </Button>
              </div>
            ))}

            <Button
              variant="contained"
              size="small"
              onClick={addExtraCharge}
            >
              Agregar cargo
            </Button>
          </div>


          <div
            style={{
              margin: '16px 0',
              padding: '16px',
              borderRadius: '8px',
              background: '#f5f5f5',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <strong>Total a cobrar:</strong>
            <span style={{ fontSize: '1.2em' }}>
              ${getGlobalTotal(uiSalidas).toFixed(2)}
            </span>
          </div>
          {omitted.length > 0 && (
            <div style={{ marginTop: '16px' }}>
              <strong>Salidas omitidas:</strong>
              <ul>
                {omitted.map(o => (
                  <li key={o.id}>
                    Salida del dia:
                    {' '}
                    {formatearFechaES(uiSalidas[o.id].meta.date)}
                    {' '}
                    {o.reason && ` — ${o.reason}`}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {excused.length > 0 && (
            <div style={{ marginTop: '16px' }}>
              <strong>Excusas aplicadas:</strong>
              <ul>
                {excused.map((e, idx) => (
                  <li key={idx}>
                    Salida del dia:
                    {' '}
                    {formatearFechaES(uiSalidas[e.salidaId].meta.date)} -
                    {' '}
                    Excusa: {e.excuse} -
                    {' '}
                    Geocerca: {uiSalidas[e.salidaId].tickets.find(t => t.id === e.ticketId).raw.geofence}
                    {' '}(${e.punishment})
                  </li>
                ))}
              </ul>
            </div>
          )}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            // disabled={committing || committed}
            disabled={(Object.keys(uiSalidas).length <= 0 || chargeable.length <= 0)}
            onClick={commitAndPrint}
          >
            {committing
              ? 'Guardando...'
              : committed
                ? 'Recibo generado'
                : 'Guardar y imprimir recibo'}
          </Button>

          <br />
          <br />
          {Object.keys(receiptsMap).length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <strong>Recibos generados:</strong>
              {Object.keys(receiptsMap).map(rid => (
                <div key={rid} style={{ display: 'flex', gap: '18px', marginBottom: '8px' }}>
                  {/*
                  <Button
                    variant="outlined"
                    onClick={() => {
                      const receiptData = buildReceiptDataFromReceiptId(Number(rid));
                      printReceipt(receiptData, false);
                    }}
                  >
                    Imprimir recibo completo#{rid}
                  </Button>
                   */}
                  <Button
                    variant="outlined"
                    onClick={() => {
                      const receiptData = buildReceiptDataFromReceiptId(Number(rid));
                      printReceipt(receiptData);
                    }}
                  >
                    Imprimir recibo minimizado#{rid}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      const receiptData = buildReceiptDataFromReceiptId(Number(rid));
                      printReceiptThermal(receiptData);
                    }}
                  >
                    Imprimir recibo #{rid}
                  </Button>
                </div>

              ))}
            </div>
          )}

        </div>
      </div>
      <RouteMapDrawer
        open={mapDrawer.open}
        onClose={() => setMapDrawer(prev => ({ ...prev, open: false }))}
        loading={mapDrawer.loading}
        positions={mapDrawer.positions}
        salidaId={mapDrawer.salidaId}
        deviceName={
          mapDrawer.salidaId && uiSalidas[mapDrawer.salidaId]
            ? devices[uiSalidas[mapDrawer.salidaId].meta.deviceId]?.name
            : ''
        }
        baseFrom={mapDrawer.baseFrom}
        baseTo={mapDrawer.baseTo}
        offsetBeforeMin={mapDrawer.offsetBeforeMin}
        offsetAfterMin={mapDrawer.offsetAfterMin}
        onExtendBefore={handleExtendRouteBefore}
        onExtendAfter={handleExtendRouteAfter}
        onResetRange={handleResetRouteRange}
      />


      <DepartureEventsMapDrawer
        open={departureEventsDrawer.open}
        onClose={() => setDepartureEventsDrawer(prev => ({
          ...prev,
          open: false,
          selectedIndex: null
        }))}
        loading={departureEventsDrawer.loading}
        salida={departureEventsDrawer.salida}
        positions={departureEventsDrawer.positions}
        selectedIndex={departureEventsDrawer.selectedIndex}
        onPositionSelect={handlePositionSelect}
      />
    </PageLayout >
  );
};

export default TicketReportPage;
